const statusCode = {
  accepted: 201,
  success: 200,
  forbidden: 403,
  unauthorized: 401,
};

export default statusCode;
